import type { NormalisedPermissionAssignment } from '@onhandtech/onhand-fe-shared/lib/api/common/permission-assignments/permission-assignments.types'
import { formatEndpoint } from '@onhandtech/onhand-fe-shared/lib/request'
import type { PayloadAction } from '@reduxjs/toolkit'
import { getConfig } from 'config/configuration'
import { requestFilterDeletePermissions, requestFilterSetPermissions } from 'redux/redux-modules'
import { delay, put, putResolve, select } from 'redux-saga/effects'
import { isNormalisedVolunteerGroup } from 'utils/type.utils'

import type { AddPermissionAssignmentPayload } from '../actions'
import { setAutomaticallyRemovingPublicPermission } from '../actions'
import type { ModalSections } from '../sections.types'
import { sectionModalsSelector } from '../selectors'

export function* addPermissionAssignmentSaga(
  action: PayloadAction<AddPermissionAssignmentPayload>,
) {
  const { target } = action.payload

  const sectionModals: ModalSections = yield select(sectionModalsSelector)

  if (!sectionModals.permissions) {
    return []
  }

  if (sectionModals.permissions.isPublic) {
    // Lets find the public permission we need to get rid of
    const publicPermissionAssignment: NormalisedPermissionAssignment | undefined =
      sectionModals.permissions.permissionAssignments.find((permission) => permission.isPublic)

    if (publicPermissionAssignment) {
      yield put(setAutomaticallyRemovingPublicPermission(true))

      yield putResolve(
        requestFilterDeletePermissions.actions.makeRequest({
          url: formatEndpoint(getConfig().endpoints.api.v5.requestFilterDeletePermissions, {
            id: publicPermissionAssignment.id,
          }),
        }),
      )

      // This is ugly, but we've got no way of knowing if the above request has completed.
      yield delay(500)
    }
  }

  const isTargetVolunteerGroup = isNormalisedVolunteerGroup(target)

  yield putResolve(
    requestFilterSetPermissions.actions.makeRequest({
      payload: {
        permission: 'VIEW',
        request_filter_set_id: sectionModals.permissions.id,
        assignee_user_group_id: isTargetVolunteerGroup ? target.id : null,
        assignee_user_id: isTargetVolunteerGroup ? null : (target.id ?? null),
      },
    }),
  )

  return []
}
